import Loading from '@MP/shared/components/Loading';

import { MHomeLoadingModal } from '../../pages/home/MHomeLoading';

/**
 * 하이드레이션 폴백 컴포넌트
 * 서버 사이드 렌더링 시 하이드레이션 중 표시되는 컴포넌트입니다.
 * 단, m/hm 진입 시에는 청크 로딩 구간부터 재택 트리의 호흡 링을 보여줘
 * 뒤이어 뜨는 스플래시까지 같은 인디케이터로 이어진다.
 */
export function HydrateFallback() {
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/m/hm')) {
    return <MHomeLoadingModal open />;
  }
  return <Loading />;
}
